import { Database, Lock, Mail, Phone, ShieldCheck } from "lucide-react";

const PrivacyPolicy = () => {
  return (
    <div className="bg-white">
      {/* Hero */}
      <section className="bg-gradient-to-r from-brand-blue to-brand-teal text-white">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-20">
          <div className="max-w-3xl">
            <div className="inline-flex items-center gap-2 rounded-full bg-white/10 px-4 py-2 text-sm font-medium mb-6">
              <ShieldCheck size={16} />
              Privacy Policy
            </div>
            <h1 className="font-heading text-4xl md:text-5xl font-bold leading-tight mb-4">
              Privacy Policy
            </h1>
            <p className="text-white/90 text-lg leading-relaxed">
              We respect your privacy and are committed to handling personal
              information responsibly, carefully, and only for purposes connected
              to our support and coordination services.
            </p>
          </div>
        </div>
      </section>

      {/* Content */}
      <section className="py-14 md:py-20 bg-brand-neutral">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white rounded-3xl shadow-sm border border-gray-100 overflow-hidden">
            <div className="px-6 sm:px-8 lg:px-10 py-8 sm:py-10">
              <div className="border-b border-gray-100 pb-6 mb-8">
                <p className="text-sm font-semibold tracking-wide uppercase text-brand-orange mb-2">
                  Effective Date
                </p>
                <p className="text-brand-text text-base">March 26, 2026</p>
              </div>

              <div className="space-y-10">
                <div>
                  <h2 className="font-heading text-2xl md:text-3xl font-bold text-brand-blue mb-4">
                    Our Privacy Commitment
                  </h2>
                  <p className="text-gray-700 leading-8">
                    Behavioral Health Navigation & Workforce Agency (BHNWA) respects
                    your privacy. Any personal information shared with us is used
                    solely for communication, coordination of services, and internal
                    record-keeping.
                  </p>
                </div>

                <div className="rounded-2xl bg-brand-blue/5 border border-brand-blue/10 p-6">
                  <div className="flex items-start gap-3">
                    <Database className="text-brand-blue mt-1 flex-shrink-0" size={22} />
                    <div>
                      <h2 className="font-heading text-2xl font-bold text-brand-blue mb-3">
                        How Information Is Used
                      </h2>
                      <div className="space-y-4 text-gray-700 leading-8">
                        <p>We may use personal information to:</p>
                        <ul className="list-disc pl-6 space-y-2">
                          <li>Respond to inquiries and communication requests</li>
                          <li>Coordinate navigation and referral support services</li>
                          <li>Maintain internal service records</li>
                          <li>Support agency administration and service follow-up</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>

                <div>
                  <h2 className="font-heading text-2xl md:text-3xl font-bold text-brand-blue mb-4">
                    Information Sharing
                  </h2>
                  <div className="space-y-4 text-gray-700 leading-8">
                    <p>
                      We do not sell or share personal information with third parties
                      except when required by law or when necessary to support service
                      coordination.
                    </p>
                    <p>
                      Any information shared for coordination purposes is handled with
                      care and only when relevant to helping connect individuals with
                      appropriate resources.
                    </p>
                  </div>
                </div>

                <div className="rounded-2xl bg-green-50 border border-green-100 p-6">
                  <div className="flex items-start gap-3">
                    <Lock className="text-green-700 mt-1 flex-shrink-0" size={22} />
                    <div>
                      <h2 className="font-heading text-2xl font-bold text-green-700 mb-3">
                        Data Responsibility
                      </h2>
                      <p className="text-gray-700 leading-8">
                        We are committed to using shared information responsibly and
                        limiting its use to communication, service coordination, and
                        internal documentation connected to our non-clinical support
                        work.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="rounded-2xl bg-brand-orange/5 border border-brand-orange/10 p-6">
                  <h2 className="font-heading text-2xl font-bold text-brand-blue mb-4">
                    Contact
                  </h2>
                  <div className="space-y-4 text-gray-700 leading-8">
                    <div className="flex items-center gap-3">
                      <Mail className="text-brand-orange flex-shrink-0" size={18} />
                      <a
                        href="mailto:info@behavioralhealthnavigation.org"
                        className="hover:text-brand-orange transition-colors break-all"
                      >
                        info@behavioralhealthnavigation.org
                      </a>
                    </div>
                    <div className="flex items-center gap-3">
                      <Phone className="text-brand-orange flex-shrink-0" size={18} />
                      <a
                        href="tel:+18328878254"
                        className="hover:text-brand-orange transition-colors"
                      >
                        +1 (832) 887-8254
                      </a>
                    </div>
                  </div>
                </div>

                <div className="pt-2 border-t border-gray-100">
                  <p className="text-sm text-gray-500 leading-7">
                    © Behavioral Health Navigation & Workforce Agency. All Rights Reserved.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPolicy;